import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { SelectionCardWebElement } from './SelectionCardWebElement';
export { SelectionCardWebElement };

/**
 * Retrieve an instance of [SelectionCardWebElement](../classes/SelectionCardWebElement.html).
 * @example
 * ```javascript
 * import { findSelectionCard } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findSelectionCard(driver, By.id('my-oj-c-selection-card'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findSelectionCard(
  driver: DriverLike,
  by: By
): Promise<SelectionCardWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type SelectionCardWebElement
  if (!(webEl instanceof SelectionCardWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'SelectionCardWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findSelectionCard(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${SelectionCardWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-selection-card', SelectionCardWebElement);
